module.exports = __webpack_public_path__ + "static/media/nft2.b6e285a9.jpeg";